import { render, staticRenderFns } from "./Misc.vue?vue&type=template&id=0b20836e&scoped=true&"
import script from "./Misc.vue?vue&type=script&lang=js&"
export * from "./Misc.vue?vue&type=script&lang=js&"
import style0 from "./Misc.vue?vue&type=style&index=0&id=0b20836e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b20836e",
  null
  
)

export default component.exports